import React from 'react';
import { motion } from 'framer-motion';
import { 
  MdEdit, 
  MdShare, 
  MdDownload, 
  MdAddCircleOutline, 
  MdLink, 
  MdMoreHoriz 
} from 'react-icons/md';

export interface Action {
  id: string;
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
}

interface ActionBarProps {
  actions?: Action[];
  className?: string;
}

const ActionBar: React.FC<ActionBarProps> = ({ actions, className = '' }) => {
  // Default actions
  const defaultActions: Action[] = [
    {
      id: 'edit',
      icon: <MdEdit size={20} />,
      label: 'Edit',
      onClick: () => console.log('Edit clicked')
    },
    {
      id: 'add-assets',
      icon: <MdAddCircleOutline size={20} />,
      label: 'Add Assets',
      onClick: () => console.log('Add Assets clicked')
    },
    {
      id: 'share',
      icon: <MdShare size={20} />,
      label: 'Share',
      onClick: () => console.log('Share clicked')
    },
    {
      id: 'link',
      icon: <MdLink size={20} />,
      label: 'Link',
      onClick: () => console.log('Link clicked')
    },
    {
      id: 'more',
      icon: <MdMoreHoriz size={20} />,
      label: 'More',
      onClick: () => console.log('More clicked')
    }
  ];

  const actionsToRender = actions || defaultActions;

  return (
    <div className={`flex justify-center ${className}`}>
      <div className="inline-flex items-center gap-2 rounded-full px-1 py-1 shadow-lg"
      style={{
        backdropFilter: "blur(10px)", 
        boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 14px 0px",
        background: "linear-gradient(90deg, rgba(33, 33, 33, 0.92), rgba(55, 55, 55, 0.92))", 
        border: "1px solid rgba(224, 224, 224, 0.13)"
        }}>
        {actionsToRender.map((action, index) => (
          <React.Fragment key={action.id}>
            <motion.button
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
              onClick={action.onClick}
              className="flex cursor-pointer items-center justify-center w-8 h-8 rounded-full hover:bg-[#616161] transition-colors text-white"
              title={action.label}
            >
              {action.icon}
            </motion.button>
            
            {/* Divider - show after "Add Assets" button */}
            {action.id === 'add-assets' && index < actionsToRender.length - 1 && (
              <div className="w-px h-6 bg-gray-300" />
            )}
          </React.Fragment>
        ))}
       
      </div>
    </div>
  );
};

export default ActionBar;
